import { activityTypesHasErrored, activityTypesIsLoading, activityTypes } from './activityTypes/activityTypesReducer';
import {
    liquidBottle, liquidBottleHasErrored, liquidBottleTakeHasErrored,
    liquidBottleReleaseHasErrored, liquidBottles
} from './liquidBottles/liquidBottlesReducer';
import { activeDayImputations, imputations, interventionsImputations } from './imputations/imputationsReducer'
import { report } from "./activityReport/activityReportReducer";
import { workOrders } from "./workOrders/workOrdersReducer";
import { current_day, dayValidationAuthorized, dayModificationAuthorized, allDays } from "./day/dayReducer";
import { riskTypes, analyseRisques, solutionTypes, analysesRisques, ppeList, accreditationTypes, } from "./analyseRisques/analyseRisquesReducer"
import { companies, } from './companies/companiesReducer'
import { habilitations } from "./habilitations/habilitationsReducer";
import { absences } from "./absences/absencesReducer";
import { loggedEmployee } from "./employees/loggedEmployeeReducer";
import { componentsPark } from "./componentsPark/componentsParkReducer";
import { searchHistory } from "./searchHistory/searchHistoryReducer";
import { interventions, intervention } from './intervention/interventionReducer';
import { products } from './product/productReducer';
import { gpsInformations } from "./gps/gpsReducer";
import { news } from './news/newsReducer';
import { siteMonitorings, siteMonitoring, notes, tags } from './siteMonitoring/siteMonitoringReducer';
import { forms, form } from './humanResources/humanResourcesReducer'
import { equipmentsEPI, equipmentEPI } from "./epi/epiReducer";

export default {
    activityTypes,
    activityTypesHasErrored,
    activityTypesIsLoading,

    loggedEmployee,

    liquidBottleHasErrored,
    liquidBottle,
    liquidBottleTakeHasErrored,
    liquidBottleReleaseHasErrored,
    liquidBottles,

    gpsInformations,
    report,
    activeDayImputations,
    imputations,
    workOrders,
    current_day,
    allDays,
    dayValidationAuthorized,
    dayModificationAuthorized,
    habilitations,
    absences,
    interventionsImputations,

    analysesRisques,
    analyseRisques,
    riskTypes,
    solutionTypes,
    ppeList,
    accreditationTypes,

    companies,

    interventions,
    intervention,

    componentsPark,

    searchHistory,

    products,

    news,

    siteMonitorings,
    siteMonitoring,
    notes,
    tags,

    forms,
    form,

    equipmentsEPI,
    equipmentEPI,
};
